import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../lib/api';
import { useAuth } from '../context/AuthContext';

function fmtDate(str) {
  if (!str) return '—';
  const [y, m, d] = str.slice(0, 10).split('-').map(Number);
  return new Date(y, m - 1, d).toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' });
}

export default function TalentDashboard() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [shoots,  setShoots]  = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/api/talent-portal/upcoming-shoots')
      .then(r => setShoots(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="main">
      <div className="topbar">
        <div>
          <div className="page-title">Welcome, {user?.name?.split(' ')[0] || 'Talent'}</div>
          <div className="page-sub">Your upcoming shoots and availability</div>
        </div>
        <div className="topbar-actions">
          <button className="btn-primary" onClick={() => navigate('/talent/availability')}>
            Set My Availability
          </button>
        </div>
      </div>

      <div className="body" style={{ maxWidth: 700 }}>
        <div style={{ display: 'flex', gap: 12, marginBottom: 28, flexWrap: 'wrap' }}>
          <div
            className="card"
            style={{ flex: 1, minWidth: 180, padding: '20px 24px', cursor: 'pointer' }}
            onClick={() => navigate('/talent/availability')}
          >
            <div style={{ fontSize: 11, color: 'var(--tx-muted)', textTransform: 'uppercase', letterSpacing: '0.07em', marginBottom: 6 }}>My Availability</div>
            <div style={{ fontSize: 22, fontWeight: 700, color: 'var(--violet)' }}>⊞</div>
            <div style={{ fontSize: 12, color: 'var(--tx-secondary)', marginTop: 6 }}>Manage your schedule</div>
          </div>
          <div
            className="card"
            style={{ flex: 1, minWidth: 180, padding: '20px 24px', cursor: 'pointer' }}
            onClick={() => navigate('/talent/scripts')}
          >
            <div style={{ fontSize: 11, color: 'var(--tx-muted)', textTransform: 'uppercase', letterSpacing: '0.07em', marginBottom: 6 }}>My Scripts</div>
            <div style={{ fontSize: 22, fontWeight: 700, color: 'var(--violet)' }}>✦</div>
            <div style={{ fontSize: 12, color: 'var(--tx-secondary)', marginTop: 6 }}>View assigned scripts</div>
          </div>
        </div>

        <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--tx-primary)', marginBottom: 14, letterSpacing: '-0.01em' }}>
          Upcoming Shoots
        </div>

        {loading ? (
          <div style={{ color: 'var(--tx-muted)', fontSize: 13 }}>Loading…</div>
        ) : shoots.length === 0 ? (
          <div className="card" style={{ padding: '28px 24px', textAlign: 'center' }}>
            <div style={{ fontSize: 28, marginBottom: 12 }}>📅</div>
            <div style={{ fontSize: 14, color: 'var(--tx-secondary)', fontWeight: 600 }}>No shoots scheduled yet</div>
            <div style={{ fontSize: 12, color: 'var(--tx-muted)', marginTop: 6 }}>Check back soon — your upcoming shoots will appear here.</div>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {shoots.map(shoot => (
              <div key={shoot.id} className="card" style={{ padding: '18px 22px' }}>
                <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 12 }}>
                  <div>
                    <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--tx-primary)' }}>
                      {shoot.script?.scriptName || '(Riff)'}
                    </div>
                    <div style={{ fontSize: 12, color: 'var(--tx-muted)', marginTop: 3 }}>
                      {shoot.client?.name}
                    </div>
                  </div>
                  <div style={{ textAlign: 'right', flexShrink: 0 }}>
                    <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--violet)' }}>
                      {fmtDate(shoot.shootScheduledDate)}
                    </div>
                    <span className={`pill pill-${shoot.status?.toLowerCase()}`} style={{ fontSize: 10, marginTop: 4, display: 'inline-block' }}>
                      {shoot.status}
                    </span>
                  </div>
                </div>
                {shoot.script?.id && (
                  <button
                    className="btn-ghost"
                    style={{ marginTop: 12, fontSize: 11, padding: '4px 10px' }}
                    onClick={() => navigate('/talent/scripts')}
                  >
                    View Script ↗
                  </button>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
